import React from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import appStyles from 'Routes/Routes.css';
import errorController from 'Components/ErrorScreens';
import RouteLoading from 'Components/RouteLoading';
import useGetList from 'Hooks/query-hooks/list/useGetList';
import useGetReduxUsers from 'Hooks/reduxHelperHooks/useGetReduxUsers';
import Header from './components/Header';
import ListTable from './components/ListTable';

const ListManagement = () => {
    const { users } = useGetReduxUsers();
    const listAPI = useGetList(users);
    const { hasError, errorCmp } = errorController([listAPI.error]);
    const { t } = useTranslation();

    if (hasError) return errorCmp;

    if (listAPI.isLoading || listAPI.isFetching) {
        return <RouteLoading />;
    }

    // typescript was complaining about what if there's no data
    // even though the api should respond with { result, total }
    if (!listAPI.data || _.isEmpty(listAPI.data)) return <span>{t('No Lists Found')}</span>;

    return (
        <div className={appStyles.landingPage}>
            <Header />
            <ListTable data={listAPI.data} />
        </div>
    );
};

export default ListManagement;
